import { render } from "./TicketNotificationForm.vue?vue&type=template&id=54cc9a5f"
import script from "./js/ticketNotificationForm.js?vue&type=script&lang=js&external"
export * from "./js/ticketNotificationForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__